import React from 'react';
import { useSelector } from 'react-redux';
import { useMembers } from 'Shared/utils/hooks';

import { useDeepEqualSelector, useWaitForCalendarWorkspacesSynced } from 'Shared/utils/hooks';

import SyncMeetingsFlowForm from '../SyncMeetingsFlowForm/SyncMeetingsFlowForm';
import { SyncMeetingsSteps } from '../types';

type Props = {
  onToggle: Function;
  newMeetingsModalData: {
    one_on_one_suggestions: Array<number>;
    group_suggestions: Array<number>;
  };
};

const connectToCalSteps = [
  SyncMeetingsSteps.newOneOnOneMeetings,
  SyncMeetingsSteps.createNewGroupWorkspaces,
  SyncMeetingsSteps.inviteTeammates,
];

function NewMeetingsModal({ onToggle, newMeetingsModalData }: Props) {
  const allRecurringMeetings = useDeepEqualSelector(state => state.user.recurringMeetings);
  const isLoading = useWaitForCalendarWorkspacesSynced();
  const workspacesLoading = useSelector(state => state.loaders.workspacesLoading);
  const { isLoading: isLoadingMembers } = useMembers();

  const suggestedRecurringMeetings = allRecurringMeetings.filter(
    ({ id }) =>
      newMeetingsModalData.one_on_one_suggestions.includes(id) || newMeetingsModalData.group_suggestions.includes(id)
  );

  const getOneOnOneSuggestions = ({ recurringMeetings }) =>
    recurringMeetings.filter(({ id }) => newMeetingsModalData.one_on_one_suggestions.includes(id));

  const getGroupSuggestions = ({ recurringMeetings }) =>
    recurringMeetings.filter(({ id }) => newMeetingsModalData.group_suggestions.includes(id));

  return (
    <SyncMeetingsFlowForm
      onToggle={onToggle}
      isLoading={isLoading || workspacesLoading || isLoadingMembers}
      steps={connectToCalSteps}
      recurringMeetings={suggestedRecurringMeetings}
      customFilterForOneOnOneSuggestions={getOneOnOneSuggestions}
      customFilterForGroupSuggestions={getGroupSuggestions}
    />
  );
}

export default NewMeetingsModal;
